import { utc } from "moment";
import { useEffect, useState } from "react";

import { ONE_MINUTE_MS } from "#/config/time";
import { useNoticeBannerFeatureFlag } from "#/hooks/featureFlags/useNoticeBannerFeatureFlag";
import { ScheduledMaintenance } from "#/types/featureFlags";

const getActiveMaintenance = (
  scheduledMaintenances: ScheduledMaintenance[],
  now = utc(),
) => {
  return scheduledMaintenances.find((maintenance) => {
    const start = utc(maintenance.startTime);
    const end = utc(maintenance.endTime);
    return now.isBetween(start, end, undefined, "[)");
  });
};

const checkVisibility = (
  scheduledMaintenances: ScheduledMaintenance[],
  now = utc(),
) => {
  return !getActiveMaintenance(scheduledMaintenances, now);
};

export const useRemoteNoticeController = () => {
  const remoteNoticeBanners = useNoticeBannerFeatureFlag();
  const [now, setNow] = useState(() => utc());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(utc());
    }, ONE_MINUTE_MS);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const alerts = remoteNoticeBanners
    .filter(
      (banner) =>
        banner?.isEnabled &&
        checkVisibility(banner.scheduledMaintenances ?? [], now),
    )
    .map(
      ({
        title = "",
        description = "",
        variant = "notice",
        actionButton: { title: action, url } = {},
      }) => ({
        title,
        variant,
        description,
        action,
        onClick: url ? () => window.open(url, "_blank") : undefined,
      }),
    );

  return {
    alerts,
  };
};
